module.exports = __webpack_public_path__ + "images/admin/bg-side-nav.png";